import { IReportTicket, TicketStatusType } from '../interfaces/report-ticket.interface';
import { IReportCustomer, IReportUnit } from '../interfaces/report.interface';

export class ReportTicketDto implements IReportTicket {
  id!: string;

  code!: string;

  status!: TicketStatusType;

  creationDate!: Date;

  finishDate?: Date;

  time!: number;

  manager!: string;

  customer!: IReportCustomer;

  unit!: IReportUnit;
}
